export default ({ query }) => {
  // Get Params from Query
  const { modelTagvalueId } = query;

  return {
    modelTagvalueId,
  };
};
